export const REG_STATUSES = [
  { value: "baru", label: "Baru", cls: "bg-slate-100 text-slate-700 border-slate-300" },
  { value: "perlu_dihubungi", label: "Perlu Dihubungi", cls: "bg-amber-50 text-amber-800 border-amber-300" },
  { value: "sudah_dihubungi", label: "Sudah Dihubungi", cls: "bg-blue-50 text-blue-700 border-blue-200" },
  { value: "menunggu_keputusan", label: "Menunggu Keputusan", cls: "bg-purple-50 text-purple-700 border-purple-200" },
  { value: "menunggu_pembayaran", label: "Menunggu Pembayaran", cls: "bg-orange-50 text-orange-700 border-orange-200" },
  { value: "terdaftar", label: "Terdaftar", cls: "bg-green-50 text-green-700 border-green-200" },
  { value: "batal", label: "Batal", cls: "bg-red-50 text-red-700 border-red-200" },
];

export const PARTICIPANT_TYPES = [
  { value: "anak", label: "Anak" },
  { value: "remaja", label: "Remaja" },
  { value: "dewasa", label: "Dewasa" },
  { value: "sekolah", label: "Sekolah" },
  { value: "perusahaan", label: "Perusahaan / Instansi" },
];

export const CLASS_TYPES = [
  { value: "reguler", label: "Reguler" },
  { value: "private", label: "Private" },
  { value: "semi_private", label: "Semi-private" },
  { value: "school_gts", label: "School Program / GTS" },
  { value: "in_company", label: "In-Company / Corporate" },
];

export const REG_MODES = ["Offline", "Online", "Hybrid"];
export const PROGRAMS = ["EFK", "EYL", "EFJ", "GE", "TOEFL Prep", "TOEFL Pred. Test", "TOEIC Prep", "TOEIC Pred Test", "IELTS Prep", "IELTS Pred Test", "Business English", "ESP", "IHT"];
export const GENDERS = ["Laki-laki", "Perempuan"];
export const REG_SOURCES = ["Website", "Chatbot", "WhatsApp", "Instagram", "TikTok", "Facebook", "Referensi teman/keluarga", "Sekolah", "Lainnya"];

export const LEMBAGA_PT = ["sekolah", "perusahaan"];
export const isMinor = (pt) => pt === "anak" || pt === "remaja";

export const regStatusLabel = (v) => REG_STATUSES.find((s) => s.value === v)?.label || v;
export const regStatusCls = (v) => REG_STATUSES.find((s) => s.value === v)?.cls || REG_STATUSES[0].cls;
export const ptLabel = (v) => PARTICIPANT_TYPES.find((s) => s.value === v)?.label || v;
export const ctLabel = (v) => CLASS_TYPES.find((s) => s.value === v)?.label || v || "-";
export const waDigits = (p) => String(p || "").replace(/\D/g, "");
